export enum BulkExportMethodsEnum {
    PerFiles = 0,
    PerSheet = 1,
}
